const cleanIDSelection = (ids) => {
  if (!ids) return [];
  return ids
    .split(/\s+|\n+|,\s*/) // Split by space, newline, or comma
    .map((id) => id.trim())
    .filter((id) => id); // Remove empty values
};

export default cleanIDSelection;
